export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const DOCUMENT_SERVER_ENDPOINT = process.env.REACT_APP_DOCUMENT_SERVER;
